import React, { Component } from "react";
import Divider from "./Divider";
import { connect } from "react-redux";

class Content extends Component {
  render() {
    return (
      <section>
        <div className="content-box">
          {this.props.langBase.slogan_1}
          <Divider />
        </div>
      </section>
    );
  }
}

const mapStateToProps = state => ({
  langBase: state.langBase
});
export default connect(mapStateToProps)(Content);
